module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2Kxj8"))).then(() => parcelRequire('d0iPb'));